import React from 'react';
import './header.module.less';

const Header: React.FC = () => {
  return (
    <div>
      <h1>Welcome to Header!</h1>
    </div>
  );
};

export { Header };
